import styled from 'styled-components';

export const Wrapper = styled.div`
   grid-area: contenido;

   section.row1 h1 {
    font-weight: bold;
    color: #383838;
  }

    .input-rut span {
      font-size: 0.8rem;
    }

    input-serie {
      margin: -1px 0px;
    }



  
  .documentotext {
    font-weight: bold;
    font-size: 0.8rem;
    font-family: inherit;
    margin-bottom: 7px;
    display: block;
    color: #383838;
  }
  .modal{
    display:flex;
  }
  .modal button{
    margin-top: -20px;
    margin-bottom: -13px;
    background-color: transparent;
    border-color: transparent;
    box-shadow: none;
    outline: 0;
  
  }

  form {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px;
  }

  form input {
    font-weight: 500;
  }
  form > div {
    margin-bottom: 1.6rem;
  }

  .footer-content > div {
    margin-bottom: 0.5rem;
  }

  .footer-content {
    p{
    font-size: 0.8rem;
    color: #333333;
    }
  }

  @media (max-width: 426px){
    form{
      display:block;
    }
    section.row1 h1{
      font-size: 1.2rem !important;
    }
    .footer-content p {
      font-size: 0.8rem;
    }
    .modal button {
        margin-left: 24px;
  }
  form ._2lUSM {
    width: 100%;
}
  }
  

  @media (max-width: 376px){
    section.row1 h1{
      font-size: 1.2rem !important;
    }
    .footer-content p {
      font-size: 0.8rem;
    }
    .modal button {
      margin-left: 24px;
    }
    form ._2lUSM {
      width: 100%;
  }
    section.row1 ._3sTov._35oaN {
    padding: 20px 1rem;
  }
  section.row1 hr, ._2OZcr ._3TO-M {
    margin-left: -1rem !important;
    margin-right: -1rem !important;
}
}

  
  
  @media (max-width: 320px){
    form input {
      font-size: 0.8rem !important;
    }
    section.row1 h1{
      font-size: 1rem !important;
    }
    .footer-content{
      p{
        font-size: 0.8rem;
      }
    }
    .modal button{
      margin-top: -14px;
      margin-left: 15px;
      margin-right: -67px;
      margin-bottom: -5px;
  }
     form ._2lUSM {
     width: 100%;
  }
    section.row1 ._3sTov._35oaN {
      padding: 20px 1rem;
    }
    section.row1 hr, ._2OZcr ._3TO-M {
      margin-left: -1rem !important;
      margin-right: -1rem !important;
    }
  }

`;

export const UsersGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
`;

export default Wrapper;